export default "__VITE_ASSET__FD53W6jr__";